import {
  base_colorHighlight,
  base_colorSurfaceMuted,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.AgentChatField {
    display: flex;
    flex-direction: column;
    width: 100%;
    ${font_md};
    font-family: ${font_family_weight_regular};
    color: ${text_colorTextPrimary};

    & .suggested-prompts-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: ${spacing(1)};
      margin: ${spacing(1)};
    }

    & .buttons-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: ${spacing(2)};
      padding: ${spacing(2)} ${spacing(3)};
    }

    & .chat-button {
      padding: ${spacing(2.5)} ${spacing(3)};
    }

    & .textarea-wrapper {
      width: 100%;
      display: flex;
      align-items: start;
      gap: ${spacing(1)};
      padding: ${spacing(0)} ${spacing(2)};
      border-radius: 8px;
      background-color: ${base_colorSurfaceMuted};

      &.with-close-button {
        padding-left: ${spacing(2)};
      }
    }

    & .loading-shimmer {
      margin: ${spacing(2)} ${spacing(3)};
      width: 200px;
      height: 16px;
    }

    & .close-button {
      padding: 4px;
      flex-shrink: 0;
    }

    & .textarea {
      max-height: 90px;
      height: fit-content;
      ${font_md};
      font-family: ${font_family_weight_regular};
      color: ${text_colorTextPrimary};
      display: inline-flex;
      padding: ${spacing(2)} ${spacing(1)};
      align-items: center;
      caret-color: ${base_colorHighlight};
      border: none;
      outline: none;
      background-color: transparent;
      resize: none;
      width: 100%;
      line-height: 1.5;
      box-sizing: border-box;

      &::placeholder {
        padding-top: ${spacing(0.5)};
        line-height: 1.5;
        opacity: 0.5;
        ${font_md};
        font-family: ${font_family_weight_regular};
        color: ${text_colorTextSecondary};
      }
    }

    & .send-button {
      height: 37px;
      flex-shrink: 0;
      align-self: flex-start;
      padding: ${spacing(2)} ${spacing(3)};

      svg g {
        fill: none !important;
      }
    }
  }
`
